export default "__VITE_ASSET__DJPJ1IbP__"